import { render, staticRenderFns } from "./dealList.vue?vue&type=template&id=2bcc1134&scoped=true"
import script from "./dealList.vue?vue&type=script&lang=js"
export * from "./dealList.vue?vue&type=script&lang=js"
import style0 from "./dealList.vue?vue&type=style&index=0&id=2bcc1134&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bcc1134",
  null
  
)

export default component.exports